import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'zt-footer',
    templateUrl: 'zt-footer.component.html',
    styleUrls: ['zt-footer.component.scss'],
})
export class ZtFooterComponent implements OnInit {
    version: string = environment.VERSION;
    apiServiceName: string = '';
    backendServiceName: string = '';
    showTooltip: boolean = false;

    constructor() {}

    ngOnInit() {
        this.apiServiceName = this.extractServiceName(environment.API_URL);
        this.backendServiceName = this.extractServiceName(environment.BACKEND_URL);
    }

    private extractServiceName(url: string): string {
        try {
            // Remove protocol (wss://, https://, http://)
            let serviceName = url.replace(/^(wss?:\/\/|https?:\/\/)/, '');
            // Remove port if present
            serviceName = serviceName.replace(/:\d+$/, '');
            // Remove domain part (everything after the first dot)
            const parts = serviceName.split('.');
            serviceName = parts.length > 0 ? (parts[0] ?? serviceName) : serviceName;
            return serviceName;
        } catch (e) {
            return url;
        }
    }
}
